import {
  DEFAULT_PAYMENT_COUNTRY,
  DEFAULT_PAYMENT_CURRENCY,
} from './default-codes/default-payment-codes';

export enum ISOs {
  USA = 'USA',
  CAN = 'CAN',
  GBR = 'GBR',
  CHE = 'CHE',
  US = 'USA',
  CA = 'CAN',
  GB = 'GBR',
  CH = 'CHE',
}

export enum RegionToISOs {
  US = ISOs.USA,
  CA = ISOs.CAN,
  GB = ISOs.GBR,
  CH = ISOs.CHE,
}

export enum ISOsToRegions {
  USA = 'US',
  CAN = 'CA',
  GBR = 'GB',
  CHE = 'CH',
}

export enum PaymentISOs {
  US = 'US',
  CA = 'CA',
  GB = 'GB',
  CH = 'CH',
}

export enum Currencies {
  USD = 'USD',
  CAD = 'CAD',
  GBP = 'GBP',
  CHF = 'CHF',
}

export {
  DEFAULT_PAYMENT_COUNTRY,
  DEFAULT_PAYMENT_CURRENCY,
} from './default-codes/default-payment-codes';

export const getCountryAndCurrencyCodes = (
  billingCountry: ISOs
): { countryCode: PaymentISOs; currencyCode: Currencies } => {
  const defaultCodes = {
    countryCode: DEFAULT_PAYMENT_COUNTRY,
    currencyCode: DEFAULT_PAYMENT_CURRENCY,
  };
  return (
    {
      [ISOs.USA]: { countryCode: PaymentISOs.US, currencyCode: Currencies.USD },
      [ISOs.CAN]: { countryCode: PaymentISOs.CA, currencyCode: Currencies.CAD },
      [ISOs.GBR]: { countryCode: PaymentISOs.GB, currencyCode: Currencies.GBP },
      [ISOs.CHE]: { countryCode: PaymentISOs.CH, currencyCode: Currencies.CHF },
    }[billingCountry] || defaultCodes
  );
};

export const postalCodeStringLocaleKey = {
  [ISOs.USA]: 'zipCode',
  [ISOs.CAN]: 'postalCode',
  [ISOs.GBR]: 'postalCode',
  [ISOs.CHE]: 'postalCode',
};

export const postalCodeInputProperties = {
  [ISOs.USA]: { maxLength: '5', pattern: '[0-9]*' },
  [ISOs.CAN]: { maxLength: '7' },
  [ISOs.GBR]: { maxLength: '10' },
  [ISOs.CHE]: { maxLength: '4', pattern: '[0-9]*' },
};

export const regionStringLocaleKey = {
  [ISOs.USA]: 'state',
  [ISOs.CAN]: 'province',
  [ISOs.GBR]: 'province',
  [ISOs.CHE]: 'canton',
};

export const regionInputProperties = {
  [ISOs.USA]: { maxLength: '2' },
  [ISOs.CAN]: { maxLength: '2' },
  [ISOs.GBR]: { maxLength: '2' },
  [ISOs.CHE]: { maxLength: '2' },
};
